module.exports = __webpack_public_path__ + "static/img/LOGO9.2859822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/LOGO9.png
// module id = iX4y
// module chunks = 0